import { jwpPlayerId } from '../constants';
import h from '../utils/htm';
import http from '../utils/http';

export default async (video, index) => { // 'comp-video'
	const 	{default: jwp} = await import('../libs/jwplayerMod'),
			loop = video.getAttribute('loop') === 'loop',
			autostart = video.getAttribute('autostart') === 'autostart',
			jwpid = video.getAttribute('jwpid').substr(1);
	if(video.querySelector('comp-background')){
		return false;
	}
	
	video.appendChild(h('div',h('div id="jw-single-'+index+'"')).Node);
	const activePlayer = jwp(video.querySelector('div > div'));
	video.removeAttribute('jwpid');

	http('https://content.jwplatform.com/feeds/' + jwpid + '.json').get()
		.then(data => {
			activePlayer.setup({
				width: 560,
				height: 315,
				autostart: autostart,
				mute: autostart,
				pid: jwpPlayerId,
				repeat: loop,
				stretching: 'exactfit',
				playlist: data.playlist
			});
		})
		.catch(()=>{});
};